import { render, staticRenderFns } from "./OrderAccepted.vue?vue&type=template&id=078eb4d4&"
import script from "./OrderAccepted.vue?vue&type=script&lang=js&"
export * from "./OrderAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports